<template>
    <div class="container-head">

        <img src="/assets/LeaderboardLines.png" class="lines" alt="">
        <img class="goblet1" src="/assets/LeaderboardGoblet.svg" alt="">
        <img class="goblet2" src="/assets/LeaderboardGoblet.svg" alt="">


        <div class="d-flex flex-column align-center mt-8">

            <div class="title">Leaderboard</div>

            <div class="subtitle mt-2">
                Climb top of the leaderboard to get extra bonus
            </div>

            <leaderboard-toggle-button class="mt-8">
                <template v-slot:last7>
                    <leaderboard-weekly-user-list />
                </template>
                <template v-slot:last30>
                    <leaderboard-monthly-user-list />
                </template>
                <template v-slot:allTime>
                    <leaderboard-all-time-user-list />
                </template>
            </leaderboard-toggle-button>

        </div>
    </div>
</template>



<script setup>

import LeaderboardToggleButton from "@/components/Leaderboard/Leaderboard-Toggle-Button.vue";
import LeaderboardWeeklyUserList from "@/components/Leaderboard/Leaderboard-Weekly-User-List.vue";
import LeaderboardMonthlyUserList from "@/components/Leaderboard/Leaderboard-Monthly-User-List.vue";
import LeaderboardAllTimeUserList from "@/components/Leaderboard/Leaderboard-All-Time-User-List.vue";

</script>



<style lang="scss" scoped>
.container-head {
    margin-top: 30px;
    position: relative;
    isolation: isolate;

    &::before {
        content: '';
        display: block;
        border-radius: 16px 16px 0 0;
        height: 260px;
        background: linear-gradient(180deg, rgba(105, 222, 251, 0.2) 0%, rgba(24, 26, 32, 0) 100%),
            radial-gradient(20.58% 102.88% at 0% 0%, rgba(244, 132, 12, 0.2) 0%, rgba(24, 26, 32, 0) 100%),
            radial-gradient(21.35% 106.73% at 100% 0%, rgba(114, 59, 235, 0.4) 0%, rgba(24, 26, 32, 0) 100%);
        position: absolute;
        top: -30px;
        left: 0;
        right: 0;
        z-index: -1;
    }

    .title {
        font-size: 32px;
        font-weight: 700;

        @media only screen and (max-width: vars.get-map-value(vars.$breakpoints, tab)) {
            font-size: 24px;
        }
    }

    .subtitle {
        font-size: 16px;
        font-weight: 500;

        @media only screen and (max-width: vars.get-map-value(vars.$breakpoints, tab)) {
            font-size: 14px;
        }
    }

    .lines {
        width: 100%;
        z-index: -1;
        position: absolute;
        top: -30px;
    }

    .goblet1 {
        position: absolute;
        left: 0;
        top: 0;
    }

    .goblet2 {
        position: absolute;
        right: 0;
        top: 0;
        transform: rotateY(180deg);
    }
}

:deep(.v-chip) {
    border-top: 1px solid #FFFFFF99;
}

@media only screen and (max-width: vars.get-map-value(vars.$breakpoints, tab)) {
    .container-head {
        .text-center {
            width: 60%;

            .mt-2 {
                font-size: 14px;
            }
        }

        .goblet1,
        .goblet2 {
            width: 130px !important;
            height: 130px !important;
        }
    }
}

@media only screen and (max-width: vars.get-map-value(vars.$breakpoints, mobile)) {
    .container-head {
        .text-center {
            width: 60% !important;
        }

        .goblet1,
        .goblet2 {
            width: 66px !important;
            height: 66px !important;
        }
    }
}
</style>
